/* global google */
import React from 'react'
import { InfoWindow } from 'react-google-maps'
import { Marker } from './Marker'
import {
  dropTimeZoneFromDate,
  get24HourTime,
} from './../../shared/libraries/utils/date'

export class PathPoint extends React.Component {
  state = { isOpen: false }

  formatDate = () => {
    const {
      point: { activity },
    } = this.props
    return get24HourTime(new Date(dropTimeZoneFromDate(activity.datetime)))
  }

  render() {
    return (
      <Marker
        draggable={false}
        position={this.props.point}
        onClick={() => this.setState({ isOpen: true })}
        icon={
          this.props.icon || {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 5,
            strokeColor: this.props.color,
          }
        }
      >
        {this.state.isOpen && (
          <InfoWindow onCloseClick={() => this.setState({ isOpen: false })}>
            <div>
              <small>{this.formatDate()}</small>
            </div>
          </InfoWindow>
        )}
      </Marker>
    )
  }
}
